import type { NumberFormat, NumberSettings } from './types';
import type { PostProcessorsRootMap } from '../../shared/post-processors';
import { GLOBAL_POSTPROCESSOR } from '../../shared/constants';
import { replaceWrongCurrencyCodeBySymbol } from './replaceWrongCurrencyCodeBySymbol';


const numberPostProcessors: PostProcessorsRootMap<NumberFormat, NumberSettings> = {
    [GLOBAL_POSTPROCESSOR]: {
        currency: replaceWrongCurrencyCodeBySymbol,
        currencyInt: replaceWrongCurrencyCodeBySymbol
    },
    ru: {
        currency: (v: string, { currency }) => {
            if (currency === 'RUB' || currency === 'RUR') {
                return v.replace(',', '.');
            }
            return v;
        },
    }
};


export {
    numberPostProcessors,
}
